import SavedSearches from './containers/SavedSearches';

export { STATE_NAME } from './constants';
export { default as reducer } from './reducer';

export default SavedSearches;
